import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Form,
  Select,
  Row,
  Col,
  Checkbox,
  Spin,
  Tooltip,
  Modal,
  Button,
  Divider,
  Input,
  Space,
} from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import InputField from "../common/htmlComponents/InputField";
import ButtonField from "../common/htmlComponents/ButtonField";
import { getRequest, patchRequest, postRequest } from "../axios";
import { Option } from "antd/lib/mentions";
import { SuccessNotificationMsg } from "../utils/Notifications";
import { authUserData } from "../utils/Helper";
import { PlusOutlined, PlusSquareFilled } from "@ant-design/icons";
import { t } from "i18next";
import PRPopUpDetailsForSteel from "../feature/PR/PRPopUpDetailsForSteel";
import ViewRFQSteel from "../feature/PR/ViewRFQSteel";
import ViewRFQApproval from "../feature/PR/ViewRFQApproval";
// import SelectVendorAddModal from "./SelectVendorAddModal";

const options = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

const NewRFQApproval = () => {
  const { rfqId, id, resetToken } = useParams();
  const navigate = useNavigate();
  const [getResponseData, setGetResponseData] = useState([]);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [rfqNumbers, setRfqNumbers] = useState("");
  const [rendomId, setRendomId] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [showSendButton, setShowSendButton] = useState(false);
  const [rfqSelectId, setRfqSelectId] = useState(null);
  const [rfqFloatId, setRfqFloatId] = useState(null);
  const [apiLoading, setapiLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [state, setState] = useState("");
  const [rfqVendorId, setRfqVendorId] = useState(null);
  const [getApi, setGetApi] = useState(false);
  const [showRejectReason, setShowRejectReason] = useState(false);
  const [rfqDetailFloatID, setRfqDetailFloatID] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingReject, setBtnLoadingReject] = useState(false);

  const addNewVendor = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const res = async () => {
    setapiLoading(true);
    try {
      let apiResponse = await getRequest(
        `rfq-material-details/get-rfq-view-detail/?rfq_id=${id}`
      );
      const materialDetailsMap = new Map();
      apiResponse.data.data.pr_city_wise_by_pr_number.forEach((cityData) => {
        cityData.city_wise_pr.forEach((city) => {
          city.site_wise_details.forEach((site) => {
            site.material_wise_details.forEach((material) => {
              const key = `${material.purchase_requisition_material_id}`;
              materialDetailsMap.set(key, {
                material_total_quantity: material.material_total_quantity,
                amount: material.amount,
                id: material.purchase_requisition_material_id, 
              });
            });
          });
        });
      });

      setGetResponseData(apiResponse.data.data);
      setRfqNumbers(apiResponse.data.data.rfq_number);
      const rendomId = apiResponse.data.data.id;
      setRendomId(rendomId);

      // setRfqSelectId(apiResponse?.data?.data?.rfq_material_details[0]?.id);
      // setRfqVendorId(
      //   apiResponse?.data?.data?.total_quantity_by_site[0]?.site_wise[0]
      //     .material_wise[0].vendors_data
      // );
      // setRfqFloatId(
      //   apiResponse?.data?.data?.rfq_material_details[0]?.rfq_master
      // );
      // setRfqDetailFloatID(apiResponse?.data?.data?.rfq_details[0]?.float_rfq);

      const initialState = {
        rfq_master: rfqId,
        rfq_material_details: apiResponse?.data?.data?.pr_city_wise_by_pr_number
          .map((cityData) => {
            return cityData.city_wise_pr.map((cityDetails) => {
              return cityDetails.site_wise_details.map((siteData) => {
                return {
                  purchase_requisition_site_name: siteData.site_id,
                  site_wise_total_quantity: siteData.site_total_quantity,
                  quantity_in_kg: siteData.site_total_quantity_by_kg,
                  site_wise_total_amount:
                    siteData.site_total_quantity_by_kg *
                    siteData.material_wise_details.reduce(
                      (acc, material) => acc + material.pr_total_amount,
                      0
                    ), // Assuming you want to calculate total amount based on materials
                  rfq_material_wise: siteData.material_wise_details.map(
                    (material) => {
                      // const materialDetailsMap = []
                      const materialKey = `${material.purchase_requisition_material_id}`;
                      const matchedMaterial =
                        materialDetailsMap.get(materialKey);
                      return {
                        id: matchedMaterial ? matchedMaterial.id : null, // Adjust as necessary
                        purchase_requisition_material:
                          material.purchase_requisition_material_id,
                        material_total_quantity: matchedMaterial
                          ? matchedMaterial.material_total_quantity
                          : material.pr_total_quantity,
                        amount: matchedMaterial
                          ? matchedMaterial.amount
                          : material.pr_total_amount,
                        material_amount: material.pr_total_amount,
                        material_qty: material.pr_total_quantity,
                        material_uom: material.material_type_uom,
                        vendor: material.vendors
                          .filter((i) => i.is_selected_vendor === true)
                          .map((vendor) => vendor.id),
                        materialInKg: material.pr_total_quantity_by_kg,
                        siteId: siteData.site_id,
                        materialId: material.material_type_name,
                      };
                    }
                  ),
                };
              });
            });
          })
          .flat(), // Flatten the array to get a single level array
      };

      setapiLoading(false);
      setState(initialState);
    } catch (err) {
      //ErrorNotificationMsg(err);
      setapiLoading(false);
    }
  };

  useEffect(() => {
    res();
  }, [getApi, reload]);


  const handleVendorChange = (value, ind, materialTypeIndex, siteIndex) => {
    const updatedState = { ...state };
    if (
      updatedState.rfq_material_details &&
      updatedState.rfq_material_details[ind] &&
      updatedState.rfq_material_details[ind].rfq_city_wise &&
      updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex] &&
      updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex]
        .rfq_material_wise &&
      updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex]
        .rfq_material_wise[materialTypeIndex]
    ) {
      updatedState.rfq_material_details[ind].rfq_city_wise[
        siteIndex
      ].rfq_material_wise[materialTypeIndex].vendor = value;

      setState(updatedState);
      setSelectedVendors(value);
    } else {
      console.error(
        "State structure doesn't match expected hierarchy or indices are invalid"
      );
    }
  };

  const handleCheckboxChange = (ind, siteIndex, checked) => {
    if (checked) {
      const updatedState = { ...state };
      updatedState.rfq_material_details[ind].rfq_site_wise_vendor[
        siteIndex
      ].vendor =
        state?.rfq_material_details[ind]?.rfq_site_wise_vendor[
          siteIndex - 1
        ].vendor;
      setState(updatedState);
    }
  };

  const handleRejectWithReason = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
    setShowRejectReason(true);
  };
  const handleSubmited = async () => {
    try {
      setBtnLoading(true);
      const response = await postRequest(
        "float-rfq/rfq-approval/" + resetToken + "/" + id + `/?action=Approve`
      );
      
      setShowRejectReason(true);
      if (response.data.success) {
        SuccessNotificationMsg("RFQ Approved Successfully");
      }
      navigate("/request-for-quotation/history");
      setBtnLoading(false);
    } catch (error) {
      console.error("Error submitting reject reason:", error);
      setBtnLoading(false);
    }
  };
  const handleSubmitRejectReason = async () => {
    const payload = {
      rfq_reject_reason: state.rfq_reject_reason,
    };
    try {
      
      const response = await postRequest(
        "float-rfq/rfq-approval/" +
          resetToken +
          "/" +
          id +
          `/?action=RejectWithReason`,
        payload
      );
      setShowRejectReason(true);
      if (response.data.success) {
        SuccessNotificationMsg("RFQ Rejected Successfully");
      }
      navigate("/request-for-quotation/history");
    } catch (error) {
      console.error("Error submitting reject reason:", error);
    }
  };
  const handleSubmitSaveDraft = async () => {
    const payload = {
      rfq_master: rfqId,
      rfq_material_details: state.rfq_material_details.map((item) => ({
        rfq_city_wise: item.rfq_city_wise.map((city) => ({
          rfq_material_wise: city.rfq_material_wise.map((material, index) => ({
            id: getResponseData.rfq_material_details[index].id,
            purchase_requisition_material:
              material.purchase_requisition_material,
            material_total_quantity: material.material_total_quantity,
            amount: material.amount,
            rfq_site_wise_vendor: material.rfq_site_wise_vendor.map((site) => ({
              purchase_requisition_site_name:
                site.purchase_requisition_site_name,
              site_wise_total_quantity: site.site_wise_total_quantity,
              site_wise_total_amount: site.site_wise_total_amount,
              vendor: site.vendor,
            })),
          })),
        })),
      })),
    };

    const payload2 = {
      rfq_master: rfqId,
      rfq_material_details: state.rfq_material_details.map((item) => ({
        rfq_city_wise: item.rfq_city_wise.map((city) => ({
          rfq_material_wise: city.rfq_material_wise.map((material, index) => ({
            id: getResponseData.rfq_material_details[index].id,
            purchase_requisition_material:
              material.purchase_requisition_material,
            material_total_quantity: material.material_total_quantity,
            amount: material.amount,
            rfq_site_wise_vendor: material.rfq_site_wise_vendor.map((site) => ({
              id: site.id,
              purchase_requisition_site_name:
                site.purchase_requisition_site_name,
              site_wise_total_quantity: site.site_wise_total_quantity,
              site_wise_total_amount: site.site_wise_total_amount,
              vendor: site.vendor,
            })),
          })),
        })),
      })),
    };

    try {
      let response;
      if (rfqVendorId === null) {
        response = await patchRequest(
          `rfq-material-details/${rfqFloatId}/create-float-rfq-draft/`,
          payload
        );
      } else {
        response = await patchRequest(
          `rfq-material-details/${rfqFloatId}/create-float-rfq-draft/`,
          payload2
        );
      }
      if (response.data.success) {
        setShowSendButton(true);
        setGetApi((prevState) => !prevState);
        SuccessNotificationMsg("RFQ Successfully Sent");

        navigate(`/request-for-quotation/history`);
      }
    } catch (error) {
      setapiLoading(false);
    }
  };


  
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>RFQ Approval</h3>
          </div>
        </div>
      </div>
      <section className="grid-sec FormSection Container">
        <div className="FormBody selectvendor">
          <Spin spinning={apiLoading}>
        
              <Form>
                <Row gutter={16}>
                  <Col className="TextFeild gutter-row">
                    <Space>
                      <label className="cp">RFQ Number</label>
                      <strong>{rfqNumbers}</strong>
                    </Space>
                  </Col>
                </Row>

                <div className="formtable">
  
                {getResponseData?.category_name?.toLowerCase().includes('steel')
          
              ? (
              <ViewRFQApproval apiResponse = {getResponseData}/>
              ) : (
                <>

                  <Row gutter={16} className="throw">
                    <Col style={{ width: "55px" }}>
                      <label className="th">Sr.</label>
                    </Col>
                    <Col style={{ width: "120px" }}>
                      <label className="th">City</label>
                    </Col>
                    <Col style={{ width: "120px" }}>
                      <label className="th">Site</label>
                    </Col>

                    <Col style={{ width: "180px" }}>
                      <label className="th">Item </label>
                    </Col>
                    <Col style={{ width: "80px" }}>
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={<span style={{ color: "#fff" }}>Quantity</span>}
                      >
                        <label
                          className="th"
                          style={{
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          Qty.
                        </label>
                      </Tooltip>
                    </Col>

                    <Col
                      style={{ width: "80px" }}
                      className="TextFeild gutter-row"
                    >
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <span style={{ color: "#fff" }}>
                            Unit Of Measurement
                          </span>
                        }
                      >
                        <label className="th">UoM.</label>
                      </Tooltip>
                    </Col>
                    <Col style={{ width: "110px" }}>
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <span style={{ color: "#fff" }}>Quantity in KG</span>
                        }
                      >
                        <label
                          className="th"
                          style={{
                            textAlign: "right",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          Qty. in Kg
                        </label>
                      </Tooltip>
                    </Col>
                    <Col
                      style={{
                        width: "120px",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                      className="TextFeild gutter-row"
                    >
                      <Tooltip
                        color={["#094E8F"]}
                        placement="top"
                        title={
                          <span style={{ color: "#fff" }}>
                            Estimated Amount
                          </span>
                        }
                      >
                        <label className="th">Est. Amount</label>
                      </Tooltip>
                    </Col>
                    <Col
                      className="TextFeild gutter-row"
                      style={{ width: "300px" }}
                    >
                      {" "}
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <span style={{ color: "#fff" }}>
                            Selected Vendors
                          </span>
                        }
                      >
                        <label className="th">Bidder(s)</label>
                      </Tooltip>
                    </Col>
                    <Col>
                      <label className="th">Remark </label>
                    </Col>
                  </Row>
                  {
                    <React.Fragment>
                      {getResponseData.pr_city_wise_by_pr_number &&
                        getResponseData.pr_city_wise_by_pr_number.map(
                          (cityData, cityIndex) => {
                            return cityData.city_wise_pr.map(
                              (cityDetails, cityDetailsIndex) => {
                                const cityTotalAmount =
                                  cityDetails.site_wise_details.reduce(
                                    (sum, site) =>
                                      sum +
                                      (typeof site.site_total_amount ===
                                      "number"
                                        ? site.site_total_amount
                                        : 0),
                                    0
                                  );

                                return (
                                  <React.Fragment
                                    key={`city-${cityDetailsIndex}`}
                                  >
                                    {cityDetails.site_wise_details.map(
                                      (siteData, siteIndex) => {
                                        const materialMap = {};

                                        siteData.material_wise_details.forEach(
                                          (material) => {
                                            const key = `${material.material_type_name}-${siteData.site_id}`;
                                            if (!materialMap[key]) {
                                              materialMap[key] = {
                                                ...material,
                                                pr_total_quantity: 0,
                                                pr_total_quantity_by_kg: 0,
                                                pr_total_amount: 0,
                                              };
                                            }
                                            materialMap[
                                              key
                                            ].pr_total_quantity +=
                                              material.material_total_quantity ||
                                              0;
                                            materialMap[
                                              key
                                            ].pr_total_quantity_by_kg +=
                                              material.material_total_quantity_by_kg ||
                                              0;
                                            materialMap[key].pr_total_amount +=
                                              material.amount || 0;
                                          }
                                        );


                                        return (
                                          <React.Fragment
                                            key={`site-${siteData.site_id}`}
                                          >
                                            {Object.values(materialMap).map(
                                              (
                                                materialData,
                                                materialDataIndex
                                              ) => {
                                               
                                                return (
                                                  <Row
                                                    gutter={16}
                                                    key={`material-${materialData.purchase_requisition_material_id}-${materialDataIndex}`}
                                                  >
                                                    <Col
                                                      style={{ width: "55px" }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      {siteIndex === 0 &&
                                                        materialDataIndex ===
                                                          0 && (
                                                          <span>
                                                            {cityDetailsIndex +
                                                              1}
                                                          </span>
                                                        )}
                                                    </Col>
                                                    <Col
                                                      style={{ width: "120px" }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      {siteIndex === 0 &&
                                                        materialDataIndex ===
                                                          0 && (
                                                          <span>
                                                            {
                                                              cityDetails.city_name
                                                            }
                                                          </span>
                                                        )}
                                                    </Col>
                                                    <Col
                                                      style={{ width: "120px" }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      {materialDataIndex ===
                                                        0 && (
                                                        <span>
                                                          {siteData.site_name}
                                                        </span>
                                                      )}
                                                    </Col>
                                                    <Col
                                                      style={{ width: "180px" }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      <span>
                                                        {
                                                          materialData.material_type_name
                                                        }
                                                      </span>
                                                    </Col>
                                                    <Col
                                                      style={{
                                                        width: "80px",
                                                        textAlign: "center",
                                                      }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      <span>
                                                        {typeof materialData.pr_total_quantity ===
                                                        "number"
                                                          ? materialData.pr_total_quantity.toLocaleString(
                                                              "en-IN",
                                                              {
                                                                maximumFractionDigits: 2,
                                                              }
                                                            )
                                                          : "0"}
                                                      </span>
                                                    </Col>
                                                    <Col
                                                      style={{ width: "80px" }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      <span>
                                                        {materialData?.material_type_uom ===
                                                        "Cubic Meter"
                                                          ? "Cu. Mtr."
                                                          : materialData?.material_type_uom ||
                                                            "-"}
                                                      </span>
                                                    </Col>
                                                    <Col
                                                      style={{
                                                        width: "110px",
                                                        textAlign: "end",
                                                      }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      <span>
                                                        {typeof materialData.pr_total_quantity_by_kg ===
                                                        "number"
                                                          ? materialData.pr_total_quantity_by_kg.toLocaleString(
                                                              "en-IN",
                                                              {
                                                                maximumFractionDigits: 2,
                                                              }
                                                            )
                                                          : "0"}
                                                      </span>
                                                    </Col>
                                                    <Col
                                                      style={{
                                                        width: "120px",
                                                        textAlign: "end",
                                                      }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      <span>
                                                        {`${currencySymbol} ${
                                                          typeof materialData.pr_total_amount ===
                                                          "number"
                                                            ? materialData.pr_total_amount.toLocaleString(
                                                                "en-IN",
                                                                {
                                                                  maximumFractionDigits: 2,
                                                                }
                                                              )
                                                            : "0"
                                                        }`}
                                                      </span>
                                                    </Col>
                                                    <Col
                                                      className="TextFeild gutter-row"
                                                      style={{ width: "300px" }}
                                                    >
                                                      <Select
                                                        mode="multiple"
                                                        maxTagCount="responsive"
                                                        style={{
                                                          width: "100%",
                                                        }}
                                                        placeholder="Please select"
                                                        value={
                                                          state
                                                            ?.rfq_material_details?.[
                                                            cityDetailsIndex
                                                          ]?.[siteIndex]
                                                            ?.rfq_material_wise?.[
                                                            materialDataIndex
                                                          ]?.vendor || []
                                                        }
                                                        filterOption={(
                                                          input,
                                                          option
                                                        ) =>
                                                          (
                                                            option?.children ??
                                                            ""
                                                          )
                                                            .toLowerCase()
                                                            .includes(
                                                              input.toLowerCase()
                                                            )
                                                        }
                                                        tagRender={({
                                                          label,
                                                        }) => (
                                                          <span
                                                            style={{
                                                              padding:
                                                                "4px 5px",
                                                              background:
                                                                "#f0f0f0",
                                                              borderRadius:
                                                                "4px",
                                                              marginRight:
                                                                "5px",
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            {label}
                                                          </span>
                                                        )}
                                                      >
                                                        {materialData.vendors?.map(
                                                          (vendor) => (
                                                            <Select.Option
                                                              key={vendor.id}
                                                              value={vendor.id}
                                                            >
                                                              {vendor.name}
                                                            </Select.Option>
                                                          )
                                                        ) || []}
                                                      </Select>
                                                    </Col>
                                                    <Col
                                                      style={{ width: "110px" }}
                                                      className="TextFeild gutter-row"
                                                    >
                                                      <span>
                                                        {materialData.remark ||
                                                          ""}
                                                      </span>
                                                    </Col>
                                                  </Row>
                                                );
                                              }
                                            )}
                                            <Row
                                              gutter={16}
                                              className="site-total-row"
                                            >
                                              <Col
                                                style={{ width: "55px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                              <Col
                                                style={{ width: "120px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                              <Col
                                                style={{
                                                  width: "120px",
                                                  margin: "5px",
                                                }}
                                                className="TextFeild gutter-row subtotal1"
                                              >
                                                Site Total
                                              </Col>
                                              <Col
                                                style={{ width: "120px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                              <Col
                                                style={{ width: "80px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                              <Col
                                                style={{ width: "80px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                              <Col
                                                style={{ width: "110px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                              <Col
                                                style={{
                                                  width: "120px",
                                                  textAlign: "end",
                                                  margin: "5px",
                                                }}
                                                className="TextFeild gutter-row subtotal1"
                                              >
                                                  {`${currencySymbol} ${
                                                    typeof siteData.site_total_amount ===
                                                    "number"
                                                      ? siteData.site_total_amount.toLocaleString(
                                                          "en-IN",
                                                          {
                                                            maximumFractionDigits: 2,
                                                          }
                                                        )
                                                      : "0"
                                                  }`}
                                              </Col>
                                              <Col
                                                style={{ width: "300px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                              <Col
                                                style={{ width: "110px" }}
                                                className="TextFeild gutter-row"
                                              ></Col>
                                            </Row>
                                          </React.Fragment>
                                        );
                                      }
                                    )}
                                    <Row gutter={16} className="city-total-row">
                                      <Col
                                        style={{ width: "55px" }}
                                        className="TextFeild gutter-row"
                                      ></Col>
                                      <Col
                                        style={{ width: "120px" }}
                                        className="TextFeild gutter-row"
                                      ></Col>
                                      <Col
                                        style={{
                                          width: "120px",
                                          margin: "5px",
                                        }}
                                        className="TextFeild gutter-row citytotal2"
                                      >
                                        City Total
                                      </Col>
                                      <Col
                                        style={{ width: "120px" }}
                                        className="TextFeild gutter-row "
                                      ></Col>
                                      <Col
                                        style={{ width: "80px" }}
                                        className="TextFeild gutter-row"
                                      ></Col>
                                      <Col
                                        style={{ width: "80px" }}
                                        className="TextFeild gutter-row"
                                      ></Col>
                                      <Col
                                        style={{ width: "110px" }}
                                        className="TextFeild gutter-row"
                                      ></Col>
                                      <Col
                                        style={{
                                          width: "120px",
                                          textAlign: "end",
                                          margin: "5px",
                                        }}
                                        className="TextFeild gutter-row citytotal2"
                                      >
                                     
                                          {`${currencySymbol} ${cityTotalAmount.toLocaleString(
                                            "en-IN",
                                            {
                                              maximumFractionDigits: 2,
                                            }
                                          )}`}
                                        
                                      </Col>
                                      <Col
                                        style={{ width: "300px" }}
                                        className="TextFeild gutter-row"
                                      ></Col>
                                      <Col
                                        style={{ width: "110px" }}
                                        className="TextFeild gutter-row"
                                      ></Col>
                                    </Row>
                                  </React.Fragment>
                                );
                              }
                            );
                          }
                        )}
                    </React.Fragment>
                  }
                  </>
              )
                }
      

                  <div className="btnwrp btnfooter">
                    <div className="approvereject">
                      <div className="reasontextwrap">
                        <div className="btnwrp2 mt-3">
                          <div style={{ marginTop: "-10px" }}>
                            <InputField
                              name="rfq_reject_reason"
                              // label="Reject Reason"

                              //rules="Please Enter Reject Reason"
                              placeholder="Enter Reject Reason"
                              //handleInputChange={handleRejectWithReason}
                              handleInputChange={handleRejectWithReason}
                              // value={}
                            />
                          </div>

                          <ButtonField
                            className="SaveGradiantBtn"
                            type="primary"
                            name="Reject With Reason"
                            // htmlType="submit"
                            label="Reject"
                            //handleRejectWithReason={handleRejectWithReason}
                            // loading={btnLoading}
                            loading={btnLoadingReject}
                            onClick={() => handleSubmitRejectReason()}
                          />

                          <ButtonField
                            label="Approve"
                            htmlType="submit"
                            type="primary"
                            onClick={handleSubmited}
                            loading={btnLoading}
                            className="SaveGradiantBtn"
                            // className="GradiantBtn SendBtn"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </Form>

          </Spin>
        </div>
      </section>
    </>
  );
};

export default NewRFQApproval;
